import { SeeqNames } from '@/main/app.constants.seeqnames';

const packageName = SeeqNames.MlService.PlsRegression.Connection.UdfPackage;
const udfName = SeeqNames.MlService.PlsRegression.Connection.UdfName;
export const UDF_NAME = `${packageName}_${udfName}`;

export const DEFAULT_NUM_COMPONENTS = 2;
export const VALIDATION_ERROR_DELAY = 500;
